import React from "react";
import { IconSize, IconProps } from "../theme";

const Diamond: React.FC<IconProps> = ({ size = IconSize.M }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Frame">
        <path
          id="Vector"
          d="M30.7497 12.3413L23.7497 4.34125C23.6561 4.23435 23.5408 4.14863 23.4115 4.08979C23.2822 4.03094 23.1418 4.00034 22.9997 4H8.9997C8.85762 4.00034 8.71724 4.03094 8.58792 4.08979C8.4586 4.14863 8.3433 4.23435 8.2497 4.34125L1.2497 12.3413C1.0864 12.5277 0.998152 12.7681 1.00208 13.016C1.00601 13.2638 1.10182 13.5013 1.27095 13.6825L15.271 28.6825C15.3645 28.7828 15.4777 28.8628 15.6035 28.9175C15.7293 28.9722 15.865 29.0004 16.0022 29.0004C16.1394 29.0004 16.2751 28.9722 16.4009 28.9175C16.5267 28.8628 16.6399 28.7828 16.7334 28.6825L30.7334 13.6825C30.9019 13.5007 30.9968 13.2628 30.9998 13.015C31.0028 12.7672 30.9137 12.5271 30.7497 12.3413ZM27.7959 12H22.4997L17.9997 6H22.5459L27.7959 12ZM9.3222 14L13.0885 23.4163L4.30095 14H9.3222ZM22.6772 14H27.6985L18.9109 23.4163L22.6772 14ZM9.45345 6H13.9997L9.4997 12H4.20345L9.45345 6Z"
          fill="#071443"
        />
      </g>
    </svg>
  );
};

export default Diamond;
